An array of email addresses for the person.

The email addresses are ordered in descending preference.

This field is redacted and an empty array is returned when a candidate or job application is deleted.
